/* import __COLOCATED_TEMPLATE__ from './cell-name.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
// @ts-ignore
import DefaultAvatars from '@intercom/pulse/lib/default-avatars';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
import { type Icon } from 'embercom/objects/inbox/command-k/icons';
interface Args {
  inboxIcon: Icon;
  inboxId: string;
  name: string;
}

interface Signature {
  Args: Args;
}

export default class CellName extends Component<Signature> {
  get defaultAvatar(): string {
    return DefaultAvatars.admins[128];
  }

  private get parsedInboxId(): string {
    let inboxId = Array.isArray(this.args.inboxId) ? this.args.inboxId[0] : this.args.inboxId;
    return String(inboxId);
  }

  private get isView(): boolean {
    return this.parsedInboxId.startsWith('view:');
  }

  /**
   * The inbox category for the route parameter.
   * Used with @models to force Ember to call the route's model hook.
   */
  get inboxCategory(): InboxCategory {
    return this.isView ? InboxCategory.View : InboxCategory.Team;
  }

  /**
   * The inbox ID for the route parameter (without the 'view:' prefix).
   * Used with @models to force Ember to call the route's model hook.
   */
  get inboxId(): string {
    return this.isView ? this.parsedInboxId.replace('view:', '') : this.parsedInboxId;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Dashboard::InboxOverview::CellName': typeof CellName;
    'inbox2/dashboard/inbox-overview/cell-name': typeof CellName;
  }
}
